import axiosInstance from '@/axios';

export const showNdcEntry = async (id) => axiosInstance.get(`/transporter/ndc_master/${id}/show`);

export const downloadCndcTemplate = async (id) => axiosInstance.get(`/transporter/ndc_master/${id}/template/cndc`, { responseType: 'blob' });

export const downloadOndcTemplate = async (id) => axiosInstance.get(`/transporter/ndc_master/${id}/template/ondc`, { responseType: 'blob' });

export const uploadNdcDocument = async (id, formData) => axiosInstance.post(`/ndc/entries/${id}/upload`, formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

export const deleteNdcAttachment = async (id) => axiosInstance.delete(`/ndc/entries/${id}/attachment`);
